export default "__VITE_ASSET__a53773ae__"